import React, { useState } from 'react';
import useChatStore from '../store/useChatStore';

const TrackOrderPage = () => {
  const { setCurrentScreen, setOrderDetails } = useChatStore();

  const [orderNumber, setOrderNumber] = useState('');
  const [email, setEmail] = useState('');

  const handleTrackOrder = () => {
    if (orderNumber && email) {
      // alert(`Tracking order ${orderNumber} for ${email}`);
      // Add logic to track order here
      const mockOrder = {
        id: orderNumber,
        status: 'paid',
        date: 'Nov 19, 2024',
        address: 'Karnataka, India',
      };

      setOrderDetails(mockOrder);
      setCurrentScreen('order-details');
    } else {
      alert('Please fill in both fields');
    }
  };

  return (
    <div className="login-page">
      {/* Order Number Input */}
      <input
        type="text"
        placeholder="Eg. #1234"
        value={orderNumber}
        onChange={(e) => setOrderNumber(e.target.value)}
        className="form-input"
      />

      {/* Email Input */}
      <input
        type="email"
        placeholder="Enter your email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className="form-input"
        style={{ marginBottom: 0 }}
      />

      {/* Track Button */}
      <button onClick={handleTrackOrder} className="form-button">
        Track
      </button>

      {/* Footer Text */}
      <p className="login-footer" onClick={() => setCurrentScreen('otp')}>Log in to manage orders</p>
    </div>
  );
};

export default TrackOrderPage;
